import Glide from '@glidejs/glide';

const TestimonialsSlider = () => {
  const slider = new Glide('.testimonials', {
    perView: 3,
    gap: 40,
    peek: {
      before: 0,
      after: 0,
    },
    type: 'carousel',
    breakpoints: {
      1024: {
        perView: 2,
        gap: 24,
        peek: {
          before: 0,
          after: 48,
        },
      },
      768: {
        perView: 1,
        gap: 24,
        peek: {
          before: 0,
          after: 48,
        },
      },
    },
  });

  slider.mount();
};

export default TestimonialsSlider;
